<template>
  <div class="shipping-type">
    <div for="shippingType" v-if="hasShipping" class="mb-2">
      {{ $t('Shipping Type') }}
    </div>
    <v-layout wrap class="shipping-type-container" fill-height>
      <template v-if="charges">
        <template v-for="charge in charges">
          <v-flex
            xs6
            sm4
            md4
            lg3
            class="mb-1"
            :key="charge.name"
            style="padding: 0"
            v-if="charge[1] && charge.name != 'additionalproduct_charge'"
          >
            <div
              class="shipping-type-item pa-1 pt-2 pb-2"
              style="height: 100%; border-radius: 5px"
              :class="{ active: shippingType == charge.name }"
              :style="{
                border:
                  shippingType == charge.name ? '2px solid ' + theme.color : ''
              }"
              @click="onSelect(charge.name)"
            >
              <img
                :src="
                  require('../../assets/img/shipping/' +
                    (charge.name.includes('other')
                      ? 'other_charge'
                      : charge.name) +
                    '_logo.png')
                "
                :alt="charge.name + 'logo'"
                style="max-width: 100%"
              />
              <div class="caption mt-2">
                <template v-if="isBearhouse && charge.name.includes('other')"
                  >ห้องเย็น Inter Express</template
                >
                <template v-if="isRos && charge.name.includes('cod_charge')"
                  >จ่ายที่ร้าน</template
                >
                <template v-else-if="charge.name.includes('other')">
                  {{
                    charge[4] && !charge[4].includes('Other')
                      ? charge[4]
                      : $t(charge.name)
                  }}
                </template>
                <template v-else-if="isFoodguru">
                  <template v-if="charge.name == 'scgexpress_charge'">
                    SCG Express / รถบริษัท
                  </template>
                  <template v-else-if="charge.name == 'flash_charge'">
                    Flash Express / ไปรษณีย์
                  </template>
                  <template v-else>
                    {{ $t(charge.name) }}
                  </template>
                </template>
                <template v-else>
                  <!-- {{ charge }} -->
                  {{ charge[9] ? charge[9] : $t(charge.name) }}
                </template>
              </div>
              <div :style="{ color: theme.color }">
                <div v-if="isBearhouse">
                  {{ currencySign }}{{ bearhouseshippingprice | decimalFormat }}
                </div>
                <!-- <div v-else-if="isFoodguru">
                  {{ currencySign }}{{ foodgurushippingprice | decimalFormat }}
                </div> -->
                <div v-else-if="isCDS">
                  <div v-if="cdsshippingprice">
                    {{ currencySign }}{{ cdsshippingprice | decimalFormat }}
                  </div>
                  <div v-else>Free</div>
                </div>
                <div v-else-if="isKhaiwhan">
                  {{ currencySign }}{{ khaiwhanshippingprice | decimalFormat }}
                </div>
                <div v-else-if="isKullastri || isBSC">
                  <div v-if="customerShippingPrice">
                    {{ currencySign
                    }}{{ customerShippingPrice | decimalFormat }}
                  </div>
                  <div v-else>Free</div>
                </div>
                <div v-else-if="pageProfile.type == 'fastdeli'">
                  {{ currencySign }}{{ customerShippingPrice | decimalFormat }}
                </div>

                <div
                  v-else-if="
                    calcuateRemoteArea(charge[0], charge.name) != 0 && isSmoothE
                  "
                >
                  <template v-if="total < 500"
                    >{{ currencySign
                    }}{{
                      calcuateRemoteArea(charge[0], charge.name) | decimalFormat
                    }}</template
                  >
                  <template v-else>Free</template>
                </div>
                <div
                  class="text-xs-center"
                  style="margin-top: 10px"
                  v-else-if="calcuateRemoteArea(charge[0], charge.name) != 0"
                >
                  <template v-if="!isNumber(charge[0])">
                    {{ charge[0] }}
                  </template>
                  <template v-else>
                    {{ currencySign
                    }}{{
                      calcuateRemoteArea(charge[0], charge.name) | decimalFormat
                    }}
                  </template>
                </div>
                <div class="text-xs-center" style="margin-top: 10px" v-else>
                  <div
                    v-if="
                      (isFoodguru && charge.name != 'skootar_charge') ||
                      !isFoodguru
                    "
                  >
                    Free
                  </div>
                  <div v-else>
                    <template>
                      (เฉพาะพื้นที่ กทม เท่านั้น คิดค่าจัดส่งตามระยะทาง)
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
        </template>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      default: undefined
    },
    pageid: {
      default: undefined
    },
    additionalproduct_charge: {
      default: undefined
    },
    shippinglist: {
      default: undefined
    },
    bearhouseshippingprice: {
      default: undefined
    },
    foodgurushippingprice: {
      default: undefined
    },
    cdsshippingprice: {
      default: undefined
    },
    khaiwhanshippingprice: {
      default: undefined
    },
    total: {
      default: undefined
    },
    customerShippingPrice: {
      default: undefined
    },
    weight: {
      default: undefined
    },
    salePageActive: {
      default: undefined
    },
    quantityType: {
      default: undefined
    },
    transportlists: {
      default: undefined
    }
  },
  data: function () {
    return {
      // shippingType: undefined,
      charges: [],
      hasShipping: false
    }
  },
  computed: {
    shippingType: {
      get() {
        return this.value && this.value.type ? this.value.type : ''
      },
      set(val) {
        let shipping = this.charges.find((el) => {
          return el.name == val
        })
        if (shipping) {
          var shippingtype = {
            type: shipping.name,
            value: shipping[0]
          }
          this.$emit('input', shippingtype)
          this.$emit('onChange', shippingtype)
        }
      }
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    ...mapGetters({
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      getSalePage: 'getSalePage',
      currencySign: 'currencySign'
    }),
    isKhaiwhan() {
      return (
        this.pageProfile &&
        this.$store.state.khaiwhan.includes(this.pageProfile.pageid)
      )
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    isRos() {
      return (
        this.pageProfile &&
        this.$store.state.ros.includes(this.pageProfile.pageid)
      )
    },
    isSmoothE() {
      return this.pageProfile && this.pageProfile.type == 'smoothe'
    },
    isKullastri() {
      return (
        this.pageProfile &&
        this.$store.state.kullastripage.includes(this.pageProfile.pageid)
      )
    },
    isBSC() {
      return (
        this.pageProfile &&
        this.$store.state.bscpage.includes(this.pageProfile.pageid)
      )
    },
    isFoodguru() {
      return this.pageProfile && this.pageProfile.type == 'foodguru'
    }
  },

  mounted: function () {
    this.initMounted()
  },
  methods: {
    initMounted() {
      const vm = this
      if (vm.pageid) {
        var charges = []
        if (vm.shippinglist) {
          for (const key in vm.shippinglist) {
            if (Object.hasOwnProperty.call(vm.shippinglist, key)) {
              var element = vm.shippinglist[key]
              if (
                vm.shippinglist[key][2] &&
                vm.getSalePage &&
                vm.getSalePage.is_active &&
                !vm.$route.query.userid
              ) {
                if (JSON.parse(vm.shippinglist[key][2]) !== null) {
                  if (
                    JSON.parse(vm.shippinglist[key][3]) &&
                    vm.quantityType > 1
                  ) {
                    vm.shippinglist[key][0] =
                      vm.shippinglist[key][0] +
                      vm.shippinglist[key][3] * (vm.quantityType - 1)
                  }
                  JSON.parse(vm.shippinglist[key][2]).map((item) => {
                    if (item.min <= vm.weight && vm.weight <= item.max) {
                      vm.shippinglist[key][0] =
                        vm.shippinglist[key][0] +
                        item.charge +
                        vm.shippinglist[key][3] * vm.quantityType
                      element = vm.shippinglist[key]
                    }
                  })
                }
                if (element[4] && element[4].includes('%')) {
                  element[0] =
                    element[0] +
                    parseFloat(
                      (
                        ((vm.total + element[0]) / 100) *
                        parseInt(element[4].split('%')[0])
                      ).toFixed()
                    )
                }
              }
              charges.push({
                ...element,
                name: key
              })
            }
          }
        }
        vm.charges = charges.sort((a, b) => {
          // equal items sort equally
          if (a.name === b.name) {
            return 0
          }
          // nulls sort after anything else
          else if (a.name === 'cod_charge') {
            return 1
          } else if (b.name === 'cod_charge') {
            return -1
          } else {
            return a.name < b.name ? -1 : 1
          }
        })
        // vm.charges = charges.sort((a, b) => {
        //   return a[0] - b[0]
        // })
        let hasShipping = vm.charges.filter((el) => {
          return el.name != 'additionalproduct_charge' && el[1]
        })
        vm.hasShipping = hasShipping.length > 0

        if (vm.value && vm.value.type) {
          vm.onSelect(vm.value.type)
        } else if (vm.hasShipping) {
          vm.onSelect(hasShipping[0].name)
        }
      }
    },
    calcuateRemoteArea(val, name) {
      if (!this.isNumber(val)) return val
      if (this.transportlists && this.transportlists.length > 0) {
        let transport = this.transportlists.find((el) => {
          return el.name == name
        })
        if (transport) {
          let { transport_cost } = transport

          return val + (transport_cost || 0)
        }
      }
      return val
    },
    isNumber(value) {
      let val = null
      try {
        val = parseInt(value)
      } catch (error) {
        return false
      }
      return typeof val === 'number' && isFinite(val)
    },
    onSelect: function (index) {
      this.shippingType = index
    }
  },
  watch: {
    shippinglist: {
      deep: true,
      immediate: true
    }

    // value: function(newVal) {
    //   if (newVal) {
    //     this.shippingType = newVal.type;
    //   }
    // },
  }
}
</script>

<style lang="scss" scoped></style>
